export const formatTimeUnit = (item) => {
  if (item.toString().length > 1) return item;
  else return `0${item}`;
};

export const generateParamString = (params) => {
  if (!params) return "";
  let paramString = "?";
  if (Array.isArray(params)) {
    if (params.length === 0) return "";
    for (let i = 0; i < params.length; i++) {
      paramString += `${params[i].toString()}${
        i !== params.length - 1 ? "&" : ""
      }`;
    }
  } else if (typeof params === "object") {
    if (Object.keys(params).length === 0) return "";
    for (const key in params) {
      paramString += `${key}=${params[key]}&`;
    }
    paramString = paramString.slice(0, -1);
  } else {
    console.error("Invalid input!");
    return "";
  }
  return paramString;
};

export const generateCoordinateLocationObject = (address, lat, long) => {
  return {
    ads_oid: "",
    long_address: address,
    latitude: lat,
    longitude: long,
    street: null,
    locality: null,
    city: null,
    country: null,
    full_object: null,
  };
};

export const normalizeLocationObject = (locationObj) => {
  if (locationObj.long_address) return locationObj;
  return {
    ads_oid: locationObj.ads_oid ?? null,
    long_address: locationObj.ipikkaadress ?? null,
    latitude: locationObj.viitepunkt_b ?? null,
    longitude: locationObj.viitepunkt_l ?? null,
    street: locationObj.aadresstekst ?? null,
    locality: locationObj.asustusyksus ?? null,
    city: locationObj.omavalitsus ?? null,
    country: "Eesti" ?? null,
    full_object: locationObj ?? null,
  };
};

export const normalizeAbbreviatedLocationObject = (location) => {
  return {
    ads_oid: null,
    long_address: location,
    latitude: null,
    longitude: null,
    street: null,
    locality: null,
    city: null,
    country: "Eesti",
    full_object: null,
  };
};

import moment from "moment";
export const hmObjectToString = (obj) => {
  return `${formatTimeUnit(obj.hour)}:${formatTimeUnit(obj.minute)}`;
};
export const timeSelectorObjectToString = (timeObj, date, format) => {
  return moment(date).hour(timeObj.hour).minute(timeObj.minute).format(format);
};

export const parseTimerData = (timerData, workerUUID) => {
  return moment
    .utc(
      timerData
        .filter((x) => x.worker === workerUUID)
        .map((x) =>
          moment
            .duration(
              moment(x.stopper_end ? moment(x.stopper_end) : moment()).diff(
                moment(x.stopper_start)
              )
            )
            .as("milliseconds")
        )
        .reduce((len, sum) => len + sum, 0)
    )
    .format("HH:mm");
};

const fieldNames = [
  {
    field: "stopper_start",
    translation: "Algus",
  },
  {
    field: "stopper_end",
    translation: "Lõpp",
  },
  {
    field: "price",
    translation: "Palk/Hind",
  },
  {
    field: "cost",
    translation: "Kulu",
  },
  {
    field: "vat",
    translation: "Käibemaks",
  },
  {
    field: "cost_coefficient",
    translation: "Koefitsent",
  },
  {
    field: "added_by_manager",
    translation: "Käsitsi juhataja lisatud",
  },
  {
    field: "name",
    translation: "Kirjeldus",
  },
  {
    field: "amount",
    translation: "Kogus",
  },
  {
    field: "confirmed",
    translation: "Kinnitus",
  },
];
export const translateFieldName = (field) => {
  return fieldNames.find((x) => x.field === field).translation ?? field;
};

export const transformFieldValue = (field, value) => {
  if (!value) return "-";
  if (["stopper_start", "stopper_end"].includes(field)) {
    return moment(value).format("DD.MM HH:mm:ss");
  } else if (field === "added_by_manager") {
    if (value.includes(";"))
      return value
        .split(";")
        .map((x) => moment(x).format("DD.MM HH:mm:ss"))
        .join("-");
    return value;
  }
  return value;
};

export const transformLocationName = (location, savedLocations) => {
  if (!location) return null;
  if (!savedLocations || savedLocations.length === 0) return null;
  if (typeof location === "string") {
    const loc = savedLocations.find(
      (x) => x.location.long_address === location
    );
    return loc ? loc.name : null;
  } else {
    const loc = savedLocations.find(
      (x) =>
        x.location.ads_oid === location.ads_oid ||
        x.location.long_address === location
    );
    return loc ? loc.name : null;
  }
};

export const parseLocation = (
  location,
  savedLocations,
  startLocation = null
) => {
  if (!location) return "-";
  let address = typeof location === "string" ? location : location.long_address;
  if (startLocation && startLocation === address) {
    return "Sama";
  }
  const savedLocation = transformLocationName(location, savedLocations);
  if (savedLocation) {
    return `${savedLocation} / ${address}`;
  }
  if (location.ads_oid) return `${address}`;
  if (location.latitude && location.longitude)
    return `${address} / (${location.latitude}, ${location.longitude})`;
  return `${address}`;
};

export const decimalToHour = (decimalHours) => {
  let hours = Math.floor(decimalHours);
  let minutes = Math.round((decimalHours - hours) * 60);
  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

const backgroundColours = [
  {
    status: 1,
    color: "bg-grey-light",
  },
  {
    status: 2,
    color: "bg-pending",
  },
  {
    status: 3,
    color: "bg-attention",
  },
  {
    status: 4,
    color: "bg-danger",
  },
  {
    status: 5,
    color: "bg-turquoise",
    backgroundColor: "bg-turquoise",
  },
  {
    status: 6,
    color: "bg-primary-dark",
    backgroundColor: "bg-grey-dark",
  },
  {
    status: 7,
    color: "bg-danger-dark",
    backgroundColor: "bg-danger-dark",
  },
];

export const borderColor = (status) => {
  return (
    backgroundColours.find((x) => x.status === status).color ?? "bg-primary"
  );
};

/**
 * Converts an integer to an array of boolean values representing bit flags
 * Similar to how chmod works, where each bit represents a setting
 *
 * @param {number} num - The integer to convert to boolean flags
 * @param {number} length - Optional: The fixed length of the returned array
 * @return {boolean[]} Array of boolean values representing each bit
 */
export const intToBooleanArray = (num, length = null) => {
  if (typeof num !== "number" || isNaN(num) || num < 0) {
    throw new Error("Input must be a non-negative number");
  }

  // Convert to binary string and then to array of 1s and 0s
  const binaryString = num.toString(2);
  const boolArray = binaryString.split("").map((bit) => bit === "1");

  // If length is specified, pad the array with false values or trim if needed
  if (length !== null) {
    if (boolArray.length < length) {
      // Pad the array with false values at the beginning
      return Array(length - boolArray.length)
        .fill(false)
        .concat(boolArray);
    } else if (boolArray.length > length) {
      // Take only the rightmost bits if array is too long
      return boolArray.slice(boolArray.length - length);
    }
  }

  return boolArray;
};

/**
 * Converts an array of boolean values back to an integer
 *
 * @param {boolean[]} boolArray - Array of boolean values
 * @return {number} The integer representation
 */
export const booleanArrayToInt = (boolArray) => {
  if (
    !Array.isArray(boolArray) ||
    !boolArray.every((item) => typeof item === "boolean")
  ) {
    throw new Error("Input must be an array of boolean values");
  }

  return boolArray.reduce((result, bit, index) => {
    return result + (bit ? Math.pow(2, boolArray.length - index - 1) : 0);
  }, 0);
};

export const intToNamedSettings = (num, settingNames) => {
  const boolArray = intToBooleanArray(num, settingNames.length);
  return settingNames.reduce((obj, name, index) => {
    obj[name] = boolArray[index];
    return obj;
  }, {});
};

/**
 * Converts an object with named settings back to an integer
 *
 * @param {Object} settings - Object with named boolean settings
 * @param {string[]} settingNames - Array of setting names in correct order
 * @return {number} The integer representation
 */
export const namedSettingsToInt = (settings, settingNames) => {
  const boolArray = settingNames.map((name) => !!settings[name]);
  return booleanArrayToInt(boolArray);
};

export const isSameCustomInterval = (moment1, moment2, minutes = 5) => {
  // Convert both moments to minutes since a reference point
  // (e.g., start of Unix epoch or any other consistent reference)
  const minutesSinceEpoch1 = moment1.unix() / 60;
  const minutesSinceEpoch2 = moment2.unix() / 60;

  // Determine which bucket each timestamp falls into
  const bucket1 = Math.floor(minutesSinceEpoch1 / minutes);
  const bucket2 = Math.floor(minutesSinceEpoch2 / minutes);

  // If they're in the same bucket, they're within the same interval
  return bucket1 === bucket2;
};
